import { reduxPageTypes } from 'src/types';
import { SET_ACTIVE_PAGE } from 'src/app/redux/redux-types';

export const pageDefaultState: reduxPageTypes.StateType = {
  activePage: '',
};

export const pageReducer = (state = pageDefaultState, action: reduxPageTypes.ActionType): reduxPageTypes.StateType => {
  switch (action.type) {
    case SET_ACTIVE_PAGE:
      return {
        ...state,
        activePage: action.payload,
      };

    default:
      return state;
  }
};
